<template>
  <side-bar :background-color="sidebarBackground" short-title="SchoolDock" title="SchoolDock">
    <template slot="links">
      <sidebar-item :link="{
        name: 'Dashboard', icon: 'fa fa-tv text-primary', path: '/dashboard'
      }" />
      <sidebar-item :link="{ name: 'Class Note', icon: 'fa fa-book text-blue', path: '/dashboard' }" />
      <sidebar-item :link="{ name: 'CBT', icon: 'fa fa-keyboard text-blue', path: '/student/exam' }" />

      <sidebar-item :link="{ name: 'Home Work', icon: 'fa fa-pen-ruler text-blue', path: '/student/home-work' }" />
      <sidebar-item :link="{ name: 'Archievement', icon: 'fa fa-trophy text-blue', path: '/student/achievement' }" />
      <sidebar-item
        :link="{ name: 'Communication Book', icon: 'fa fa-bell text-blue', path: '/student/communication-book' }" />

      <sidebar-item
        :link="{ name: 'Report Card', icon: 'fa fa-chart-simple text-blue', path: '/student/report-card' }" />
      <div class="dropdown-divider"></div>      
      <sidebar-item :link="{name: 'Log Out', icon: 'fa fa-right-from-bracket text-blue', path: '/'}"  @click="logout"/> 
    </template>
  </side-bar>
</template>
<script>
export default {
  data() {
    return {
      sidebarBackground: 'vue' //vue|blue|orange|green|red|primary
    };
  },
   methods: {  
    logout() {
      this.$store.dispatch("auth/Logout").then(() => {
        this.$router.push("/login");
      });
    },   
  },
}
</script>
